module.exports = __webpack_public_path__ + "assets/01.5d19bd67.pdf";